import { useQuery } from '@tanstack/react-query';

export interface PortalNavItem {
  id: string;
  area: string;
  label: string;
  url: string | null;
  descricao: string | null;
  icone: string | null;
  parent_id: string | null;
  externo: boolean;
  ordem: number;
  ativo: boolean;
}

/**
 * TEMPORÁRIO — mock local, remover no desenvolvimento do backend. Não existe rota de
 * navegação do portal público na API (`apps/api/src/modulos/` só tem `eu`, `govbr` e
 * `senha`), e a tela precisa existir antes do backend para validação com a SMT/DTP
 * (CLAUDE.md, seção "Proibido", exceção de 2026-08-22). Este array some inteiro
 * quando a rota real entrar, e `usePortalNav` volta a chamar `chamarApi`.
 */
const PORTAL_NAV_MOCK: PortalNavItem[] = [
  {
    id: 'nav-exemplo-01',
    area: 'menu_principal',
    label: 'Início',
    url: '/portal',
    descricao: null,
    icone: null,
    parent_id: null,
    externo: false,
    ordem: 1,
    ativo: true,
  },
  {
    id: 'nav-exemplo-02',
    area: 'menu_principal',
    label: 'Como funciona',
    url: '/portal/como-funciona',
    descricao: 'Entenda as etapas do transporte escolar gratuito',
    icone: null,
    parent_id: null,
    externo: false,
    ordem: 2,
    ativo: true,
  },
  {
    id: 'nav-exemplo-03',
    area: 'menu_principal',
    label: 'Dúvidas frequentes',
    url: '/portal/duvidas-frequentes',
    descricao: null,
    icone: null,
    parent_id: null,
    externo: false,
    ordem: 3,
    ativo: true,
  },
  {
    id: 'nav-exemplo-04',
    area: 'footer_servicos',
    label: 'Solicitar transporte',
    url: '/portal/quem-pode-participar',
    descricao: null,
    icone: null,
    parent_id: null,
    externo: false,
    ordem: 1,
    ativo: true,
  },
  {
    id: 'nav-exemplo-05',
    area: 'footer_institucional',
    label: 'Secretaria Municipal de Mobilidade e Transportes',
    url: 'https://www.prefeitura.sp.gov.br/smt',
    descricao: null,
    icone: null,
    parent_id: null,
    externo: true,
    ordem: 1,
    ativo: true,
  },
  {
    id: 'nav-exemplo-06',
    area: 'gov_topbar',
    label: 'gov.br',
    url: 'https://www.gov.br',
    descricao: null,
    icone: null,
    parent_id: null,
    externo: true,
    ordem: 1,
    ativo: true,
  },
];

export function usePortalNav(area?: string) {
  return useQuery<PortalNavItem[]>({
    queryKey: ['portal-navegacao', area],
    // TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
    queryFn: async () =>
      PORTAL_NAV_MOCK.filter((item) => !area || item.area === area).sort(
        (a, b) => a.ordem - b.ordem,
      ),
    staleTime: 10 * 60_000,
  });
}
